import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';

// Trazabilidad de inventario (PRODUCT_VISION cap. 4.9): todo cambio de
// stock queda registrado con tipo, cantidad y usuario. Las ventas se
// registran desde la función registrar_venta en la BD.
export async function registrarMovimiento({ producto, tipo, cantidad, stockAnterior, stockNuevo, motivo }) {
  const { data: sesion } = await supabase.auth.getUser();
  const { error } = await supabase.from('movimientos_inventario').insert([{
    negocio_id: getNegocioId(),
    producto_id: producto.id || null,
    codigo_producto: producto.codigo || null,
    nombre_producto: producto.nombre || null,
    tipo,
    cantidad,
    stock_anterior: stockAnterior ?? null,
    stock_nuevo: stockNuevo ?? null,
    motivo: motivo || null,
    usuario_id: sesion?.user?.id || null,
  }]);
  if (error) throw error;
}

export async function obtenerMovimientos({ productoId = null, limite = 50 } = {}) {
  let query = supabase
    .from('movimientos_inventario')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .order('creado_en', { ascending: false })
    .limit(limite);
  if (productoId) query = query.eq('producto_id', productoId);
  const { data, error } = await query;
  if (error) throw error;
  return data || [];
}
